import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const moveToContract = createApi('pricememo', 'PUT');

const MoveToContract = createSlice({
  name: 'MoveToContract',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(moveToContract.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(moveToContract.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(moveToContract.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default MoveToContract.reducer;